export const Config = {
    googleMapsApiKey: "AIzaSyBAqFqA8wZ96CN3p53TZ9MoQ_cIOizU8BQ"
}